var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Menu } from '../Menu';
import { LazyLoader } from '../../../ts/components/LazyLoader';
import { FrontPage } from '../../pages/front-page';
export class Filters extends Component {
    constructor() {
        super('Filters', false);
        this.isInitialized = false;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Filters event listeners
            $('.filters input[type="radio"]').on('click', (event, radio) => {
                const name = radio.attr('name');
                const value = radio.attr('value');
                if (name == 'placholder' && value == 'archives') {
                    $('#category-selection').get(0).checked = false;
                    $('#placholder-archives').get(0).checked = true;
                    $('#category-all').get(0).checked = true;
                }
                if ((name == 'display' || name == 'sorting') && $('#category-selection').get(0).checked) {
                    $('#category-selection').get(0).checked = false;
                    $('#placholder-archives').get(0).checked = true;
                    $('#category-all').get(0).checked = true;
                }
                if (name == 'category') {
                    if (value == 'selection') {
                        $('#placholder-archives').get(0).checked = false;
                        $('#sorting-date').get(0).checked = true;
                        $('#sorting-client').get(0).checked = false;
                        $('#display-images').get(0).checked = true;
                        $('#display-text').get(0).checked = false;
                    }
                    else {
                        $('#placholder-archives').get(0).checked = true;
                    }
                }
                if (this.isInitialized)
                    this.updateProjectList();
                this.saveFilters();
            });
            // Click on logo resets session storage
            $('.logo a').on('click', () => {
                sessionStorage.removeItem('filters');
            });
            // if url has query params remove them for aesthetic reasons
            if (window.location.search)
                window.history.pushState({}, document.title, '/');
            // Load filters from session storage
            this.loadFilters();
            this.isInitialized = true;
            this.success();
        });
    }
    getFilters() {
        return {
            category: $('.filters input[name="category"]:checked').attr('value'),
            sorting: $('.filters input[name="sorting"]:checked').attr('value'),
            display: $('.filters input[name="display"]:checked').attr('value')
        };
    }
    saveFilters() {
        sessionStorage.setItem('filters', JSON.stringify(this.getFilters()));
    }
    loadFilters() {
        const filters = JSON.parse(sessionStorage.getItem('filters'));
        if (filters) {
            if (filters.category == 'selection')
                return;
            $('body').addClass('is-archive');
            $('#placholder-archives').get(0).checked = true;
            $('.filters input[name="category"]').each((radio) => {
                radio.get(0).checked = radio.attr('value') == filters.category;
            });
            $('.filters input[name="sorting"]').each((radio) => {
                radio.get(0).checked = radio.attr('value') == filters.sorting;
            });
            $('.filters input[name="display"]').each((radio) => {
                radio.get(0).checked = radio.attr('value') == filters.display;
            });
        }
        else {
            return;
        }
        if (!$('body').hasClass('single-project'))
            this.updateProjectList(true);
    }
    updateProjectList() {
        return __awaiter(this, arguments, void 0, function* (clearProjectList = false) {
            const filters = this.getFilters();
            if (!$('body').hasClass('home')) {
                window.location.href = '/?category=' + filters.category + '&sorting=' + filters.sorting + '&display=' + filters.display;
            }
            if (clearProjectList)
                $('#project-list').empty();
            $('.spinner').removeClass('d-none');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_projects',
                    category: filters.category,
                    sorting: filters.sorting,
                    display: filters.display
                },
                dataType: 'html'
            });
            $('#project-list').empty().append(response);
            if ($('.project-list-text').length > 0) {
                $('body').addClass('project-list-layout-text');
            }
            else {
                $('body').removeClass('project-list-layout-text');
            }
            LazyLoader.refreshImageList();
            LazyLoader.checkImageVisibility();
            console.log(filters.display);
            if (filters.display == 'images') {
                console.log('image');
                $('.logo-archive').addClass('is-behind');
            }
            else {
                $('.logo-archive').removeClass('is-behind');
            }
            if (filters.category == 'selection') {
                $('body').removeClass('is-archive');
            }
            else {
                $('body').addClass('is-archive');
                if (filters.category == 'all') {
                    $('.logo-archive p').text('Archives');
                }
                else {
                    $('.logo-archive p').text($(`.filters input[value="${filters.category}"]`).next('label').text());
                }
            }
            $('.spinner').addClass('d-none');
            $('body').css('--scroll-top', '0px');
            Menu.enablePageScroll();
            if ($(window).width() < 992) {
                FrontPage.closeProject();
                Menu.closeMenu();
            }
        });
    }
}
